<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <tip-control></tip-control>
      <tip-view></tip-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import TipControl from "@/components/tips/tipControl";
import TipView from "@/components/tips/tipView";

export default {
  data() {
    return {};
  },
  methods: {},
  computed: {},
  mounted() {},
  components: {
    TipControl,
    TipView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
